<div class="thp-form-container">
  <div class="thp-message">
    <h1 class="thp-header"> {{ "talent-happy-path.initial-interview-questions.no-questions-page.header" | translate }}</h1>
    <p class="thp-sub-header"> {{ "talent-happy-path.initial-interview-questions.no-questions-page.sub-header" | translate }} </p>
  </div>
  <div class="button-container double-button-container">
    <button mat-button class="double-custom-button back-button" (click)="clickBackButton()"><mat-icon>arrow_back</mat-icon> {{ "talent-happy-path.buttons.back" |translate }} </button>
    <button  mat-button class="custom-button double-custom-button" (click)="clickSubmitButton()"> {{ "talent-happy-path.buttons.submit" |translate }} </button>
  </div>
</div>
